import c0 from './auto_hint_controller';
import c1 from './valor_total_controller';
export const definitions = [
	{identifier: 'auto-hint', controllerConstructor: c0},
	{identifier: 'valor-total', controllerConstructor: c1},
];
